import { CommonModule } from '@angular/common';
import { Component, computed, input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-parent-learn-progress',
  standalone: true,
  imports: [CommonModule, TranslatePipe],
  templateUrl: './parent-learn-progress.component.html',
  styleUrl: './parent-learn-progress.component.scss',
})
export class ParentLearnProgressComponent {
  percent = input(0);
  completedCount = input(0);
  totalCount = input(0);
  totalPoints = input(0);
  /** Compact strip for mobile active-lesson mode */
  compact = input(false);
  /** Segment bar only — no panel chrome (e.g. course grid cards) */
  inline = input(false);

  readonly ringOffset = computed(() => {
    const circumference = 2 * Math.PI * 42;
    const pct = Math.min(100, Math.max(0, this.percent()));
    return circumference - (pct / 100) * circumference;
  });

  readonly segmentIndexes = computed(() =>
    Array.from({ length: Math.max(0, this.totalCount()) }, (_, i) => i),
  );
}
